import TableauViz from "../components/tableau/TableauViz";
import { setUserId } from '@amplitude/analytics-browser';
import AuthProvider from "../providers/AuthProvider";
import React from "react";
import { Button } from "@mui/material";
import Dashboard from "./dashboards/PerformanceDashboard";
import CurrentClientProvider from "../providers/CurrentClientProvider";


function Home(props) {
    const auth = AuthProvider.useAuth()
    const [showNewExperience, setShowNewExperience] = React.useState(false)
    const currentClient = CurrentClientProvider.useClient()
    const typeformInitialized = React.useRef(false);

    React.useEffect(() => {
        if (auth.user) {
            setUserId(auth.user.id)
        }
    }, [auth.user])

    React.useEffect(() => {
        document.title = 'Retail ORBIT: Home'

        return () => {
            setShowNewExperience(true);
        }
    }, [])

    React.useEffect(() => {
        if (currentClient.client && currentClient.client.Id) {
            const clientId = parseInt(currentClient.client.Id);
            setShowNewExperience(false);
        }
    }, [currentClient.client])

    // Typeform script handling - only load when showNewExperience is true
    React.useEffect(() => {
        if (!showNewExperience) {
            // Don't load typeform if not showing new experience
            return;
        }

        // Create script element
        const script = document.createElement('script');
        script.src = "//embed.typeform.com/next/embed.js";
        script.async = true;
        
        // Function to initialize Typeform after script loads
        script.onload = () => {
            if (window.tf && !typeformInitialized.current) {
                // Force Typeform to scan for elements with data-tf-* attributes
                window.tf.load();
                typeformInitialized.current = true;
            }
        };
        
        // Append script to document
        document.body.appendChild(script);
        
        // Cleanup function to remove script when component unmounts or showNewExperience becomes false
        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
            typeformInitialized.current = false;
        };
    }, [showNewExperience]);

    // Dedicated TypeForm feedback button component
    const TypeformFeedbackButton = () => {
        return (
            <div 
                className="fixed bottom-4 right-4 z-50"
                data-tf-live="01JT65AY4DKD6G9RNVBC65RAX3"
            ></div>
        );
    };

    return (
        <>
            {currentClient.client && currentClient.client.Id ?
                <button
                    onClick={() => {
                        setShowNewExperience(!showNewExperience)
                    }}
                    className="mb-2 mt-2 bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded"
                >
                    {showNewExperience ? 'Return to Classic Dashboard' : 'Show New Dashboard'}
                </button>
                : null}
            {showNewExperience ? (
                <>
                    <Dashboard />
                    <TypeformFeedbackButton />
                </>
            ) : (
                <TableauViz />
            )}
        </>
    )
}

export default Home